import React from "react";

import PageHeading from "2g-page-heading";

import ProvozniInformaceForm from "b2b/components/provozni-informace-form";

export function ProvozniInformaceFormExample() {
  return (
    <>
      <PageHeading>ProvozniInformaceForm</PageHeading>
      <div data-testid="ProvozniInformaceForm">
        <ProvozniInformaceForm moduleKey="ProvozniInformaceForm" />
      </div>
    </>
  );
}

ProvozniInformaceFormExample.propTypes = {};

export default React.memo(ProvozniInformaceFormExample);
